import api from 'core/api';

export const getWorkoutHeats = (workoutId) => api.get(`workouts/${workoutId}/heats`);
export const resetWorkoutHeats = (workoutId) => api.put(`workouts/${workoutId}/heats/reset`);
export const postWorkoutHeat = (data) => api.post(`workouts/${data.workoutId}/heats`, data);
export const saveWorkoutHeatsUsers = (data) =>
  api.post(`workouts/${data.workoutId}/heats_users`, data);
